// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__352b-","buttons":"PendingPaymentAlert_buttons__2uwaT"};